import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { SafeBackService } from 'app/core/services/safe-back.service';

/**
 * #1349: same 404 copy as the shared error page, but rendered inside
 * `LayoutComponent` so an unmatched path under the authenticated shell keeps
 * the nav/topbar instead of dropping to the bare `/errors/not-found` page —
 * same reasoning as `InShellForbiddenComponent`. Registered as the trailing
 * wildcard in `admin-feature.routes.ts`.
 */
@Component({
    selector: 'app-in-shell-not-found',
    standalone: true,
    imports: [RouterModule, TranslocoModule],
    templateUrl: './in-shell-not-found.component.html',
})
export class InShellNotFoundComponent {
    private readonly _safeBack = inject(SafeBackService);

    goBack(): void {
        this._safeBack.goBack();
    }
}
